import {
	Button,
	Col,
	Collapse,
	Form,
	FormGroup,
	Input,
	Label,
	Row,
	Spinner,
} from 'reactstrap';
import avatar from '../assets/imgs/new/avatar.png';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import {
	createFeedback,
	getFaqs,
	getFeedbacks,
} from '../redux/actions/feedback.action';
import Rating from '@mui/material/Rating';
import Box from '@mui/material/Box';
import { createCustomerSupport } from '../redux/actions/customersupport.action';
import MainHeader from '../components/MainHeader';

const labels = {
	1: '1 Star',
	2: '2 Stars',
	3: '3 Stars',
	4: '4 Stars',
	5: '5 Stars',
};

const Feedback = () => {
	const [isOpen, setIsOpen] = useState(-1);
	const [tab, setTab] = useState(-1);
	const [ratingValue, setRatingValue] = useState(5);
	const [hover, setHover] = useState(-1);
	const [fDesc, setFDesc] = useState('');
	const [customerDesc, setCustomerDesc] = useState('');
	const { faqs, loading } = useSelector(state => state.feedback);
	const customerSupport = useSelector(state => state.customerSupport);
	const authUser = useSelector(state => state.authUser);
	const { feedbacks } = useSelector(state => state.feedback);
	const dispatch = useDispatch();
	const toggle = id => setIsOpen(id);
	useEffect(() => {
		if (faqs.length == 0) {
			dispatch(getFaqs());
		}
		if (feedbacks.length == 0) {
			dispatch(getFeedbacks(authUser.id));
		}
	}, []);
	return (
		<>
			<div className='container-fluid pt-3'>
				<MainHeader heading={'Feedback'} />
				<hr />
				{feedbacks.length < 1 && (
					<>
						<h5 className='font-weight-bold'>Feedback</h5>

						<Form
							onSubmit={e => {
								e.preventDefault();
								let obj = {
									description: fDesc,
									rating: ratingValue,
									user_id: authUser.id,
									status: 'submitted',
								};
								dispatch(createFeedback(obj)).then(res => {
									setFDesc('');
								});
							}}
						>
							<Row>
								<Col xl='6'>
									<FormGroup>
										<Label>Name</Label>
										<Input
											required
											value={
												authUser.firstname +
												' ' +
												authUser.lastname
											}
											type='text'
											readOnly
										/>
									</FormGroup>
								</Col>
								<Col xl='6'>
									<FormGroup>
										<Label>Email</Label>
										<Input
											required
											value={authUser.email}
											type='email'
											readOnly
										/>
									</FormGroup>
								</Col>
							</Row>
							<FormGroup>
								<Label>Description</Label>
								<Input
									required
									rows='5'
									type='textarea'
									value={fDesc}
									onChange={e => setFDesc(e.target.value)}
								/>
							</FormGroup>
							<p className='f-14 font-weight-bold'>
								Give a rating for something
							</p>
							<Box
								sx={{
									width: 200,
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<Rating
									required
									name='hover-feedback'
									value={ratingValue}
									precision={1}
									onChange={(event, newValue) => {
										setRatingValue(newValue);
									}}
									onChangeActive={(event, newHover) => {
										setHover(newHover);
									}}
									// emptyIcon={<StarIcon style={{ opacity: 0.55 }} fontSize="inherit" />}
								/>
								{ratingValue !== null && (
									<Box sx={{ ml: 2 }}>
										{
											labels[
												hover !== -1
													? hover
													: ratingValue
											]
										}
									</Box>
								)}
							</Box>
							<div className='d-flex align-items-center'>
								{/* <i className="fa fa-star" style={{ color: "#FBBB00" }}></i>
            {new Array(4).fill(1).map(() => (
                <i className="ml-2 fa fa-star-o"></i>
            ))} */}
								{/* <div
                className="px-2 ml-2 f-14 text-white"
                style={{ backgroundColor: "#FBBB00", borderRadius: 4 }}
            >
                Five Stars
            </div> */}
							</div>
							<div className='d-flex mt-4'>
								<Button
									className='ml-auto btn-outline dashboard-btn'
									type='submit'
									disabled={loading}
								>
									{loading ? <Spinner size='sm' /> : 'Send'}
								</Button>
							</div>
						</Form>
					</>
				)}
				<h5 className='font-weight-bold mt-5'>Customer Support</h5>

				<Form
					onSubmit={e => {
						e.preventDefault();
						let obj = {
							descriptin: customerDesc,
							user_id: authUser.id,
							status: 'submitted',
						};
						dispatch(createCustomerSupport(obj)).then(res => {
							setCustomerDesc('');
						});
					}}
				>
					<Row>
						<Col xl='6'>
							<FormGroup>
								<Label>Name</Label>
								<Input
									required
									type='text'
									value={
										authUser.firstname +
										' ' +
										authUser.lastname
									}
									readOnly
								/>
							</FormGroup>
						</Col>
						<Col xl='6'>
							<FormGroup>
								<Label>Email</Label>
								<Input
									required
									type='email'
									value={authUser.email}
									readOnly
								/>
							</FormGroup>
						</Col>
					</Row>
					<FormGroup>
						<Label>Description</Label>
						<Input
							required
							rows='5'
							type='textarea'
							value={customerDesc}
							onChange={e => setCustomerDesc(e.target.value)}
						/>
					</FormGroup>
					<div className='d-flex mt-4'>
						<Button
							className='ml-auto btn-outline dashboard-btn'
							type='submit'
							disabled={customerSupport.loading}
						>
							{customerSupport.loading ? (
								<Spinner size='sm' />
							) : (
								'Send'
							)}
						</Button>
					</div>
				</Form>
				<h5 className='font-weight-bold mt-5'>Faqs</h5>

				<div className='tabs mb-5'>
					<span onClick={() => setTab(-1)}>All</span>
					{faqs.map((faq, idx) => (
						<span
							onClick={e => setTab(idx)}
							className={`tab-item ml-4 ${
								tab == idx ? 'active' : ''
							}`}
						>
							{faq.name}
						</span>
					))}
				</div>
				<h3 className='font-weight-bold' style={{ color: '#000000' }}>
					{tab != -1 ? faqs.length > 0 && faqs[tab].name : 'All'}
				</h3>
				{tab != -1
					? faqs.length > 0 &&
					  faqs[tab].questions.map((quest, idx) => (
							<>
								<hr className='custom-hr my-4' />
								<div
									className='d-flex pointer align-items-center '
									onClick={e =>
										toggle(isOpen != idx ? idx : -1)
									}
								>
									<i
										className='fa fa-angle-down'
										style={{ color: '#D93D13' }}
									></i>
									<h6 className='ml-2 m-0'>{quest.que}</h6>
								</div>
								<Collapse isOpen={isOpen == idx}>
									<p
										className='my-3 text-muted'
										style={{ marginLeft: 100 }}
									>
										{quest.ans}
									</p>
								</Collapse>
							</>
					  ))
					: faqs.length > 0 &&
					  faqs.map(
							(faq, index) =>
								faq.questions.length > 0 &&
								faq.questions.map((quest, idx) => {
									return (
										<>
											<hr className='custom-hr my-4' />
											<div
												className='d-flex pointer align-items-center'
												onClick={e =>
													toggle(
														isOpen != idx ? idx : -1
													)
												}
											>
												{/* {console.log('isopen', isOpen, 'idex', idx)} */}
												<i
													className='fa fa-angle-down'
													style={{ color: '#D93D13' }}
												></i>
												<h6 className='ml-2 m-0'>
													{quest.que}
												</h6>
											</div>
											<Collapse isOpen={isOpen == idx}>
												<p
													className='my-3 text-muted'
													style={{ marginLeft: 100 }}
												>
													{quest.ans}
												</p>
											</Collapse>
										</>
									);
								})
					  )}
			</div>
		</>
	);
};

export default Feedback;
